export default "__VITE_ASSET__CaMMKmKx__"